module.exports = __webpack_public_path__ + "img/flag.49b8b357.png";